import { useState } from "react";
import { MutationHookOptions, useMutation } from "@apollo/react-hooks";

import { UpdateSamplingsMutation, UpdateSamplingsMutationVariables } from "@models/graphql";
import { GraphQL } from "@graphql/graphQL";
import { message } from "antd";

const defaultUpdateShipmentStatusOptions: MutationHookOptions<UpdateSamplingsMutation, UpdateSamplingsMutationVariables> = {

};

export const useUpdateSamplings = (options?: MutationHookOptions<UpdateSamplingsMutation, UpdateSamplingsMutationVariables>) => {

    const [hookState, setHookState] = useState<{
        isLoading: boolean;
        data?: UpdateSamplingsMutation;
        error?: string;
    }>({
        isLoading: false
    });

    const [mutation] = useMutation<UpdateSamplingsMutation, UpdateSamplingsMutationVariables>(GraphQL.updateSamplings);

    const updateSamplings = async (variables: UpdateSamplingsMutationVariables) => {
        setHookState({
            isLoading: true
        });

        try {
            const response = await mutation({
                ...defaultUpdateShipmentStatusOptions,
                ...options,
                variables
            });

            setHookState({
                data: response.data,
                isLoading: false
            });

            return response;
        } catch (error) {

            setHookState({
                error,
                isLoading: false
            });
        }
    };

    return {
        isLoading: hookState.isLoading,
        error: hookState.error,
        data: hookState.data,
        updateSamplings
    };
};
